import { render } from "./TuDoudb.vue?vue&type=template&id=028279de&scoped=true"
import script from "./TuDoudb.vue?vue&type=script&lang=js"
export * from "./TuDoudb.vue?vue&type=script&lang=js"

import "./TuDoudb.vue?vue&type=style&index=0&id=028279de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-028279de"]])

export default __exports__